import BaseService from './base.service';

export default class WhyChooseUsService extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    getWhyChooseList = query => {
        return this.get('/why-choose-us', query);
    };
}
